<template>
  <vue-chart v-if="chartData" :type="type" :data="chartData" :options="options" :height="height"></vue-chart>
</template>

<script>
import VueChart from "vue-chart-js";

export default {
  name: "chart-box",

  components: {
    VueChart
  },

  props: {
    type: {
      type: String,
      default: "bar"
    },

    dataUrl: {
      type: String,
      required: true
    },

    params: {},

    options: {
      type: Object,
      default: () => { }
    },

    height: {}
  },

  data() {
    return {
      chartData: null
    };
  },

  created() {
    this.load();
  },

  computed: {
    filteredParams() {
      let params = {};

      for (let field in this.params) {
        if (this.params[field]) {
          params[field] = this.params[field];
        }
      }

      return params;
    }
  },

  watch: {
    dataUrl() {
      this.load();
    },

    params: {
      deep: true,
      handler() {
        this.load();
      }
    }
  },

  methods: {
    dataUrlWithQueryString() {
      let query = "";

      if (this.params) {
        let params =
          typeof this.params == "function"
            ? this.params()
            : this.filteredParams;

        query = new URLSearchParams(params).toString();
      }

      let sign = this.dataUrl.includes("?") ? "&" : "?";

      return this.dataUrl + sign + query;
    },

    load() {
      this.chartData = null;

      this.$http.get(this.dataUrlWithQueryString()).then(response => {
        this.chartData = response.data.data;
      });
    }
  }
};
</script>
